import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";

import { ReportCell } from "@/types/evaluate";

export const CompareDiffCell = ({ cell }: { cell: ReportCell }) => {
  const sourceType = typeof cell?.value?.value?.source;
  const targetType = typeof cell?.value?.value?.target;

  if (sourceType !== targetType) {
    return (
      <div className="text-xs text-red-400">
        Type mismatch: source is {sourceType}, target is {targetType}
      </div>
    );
  }

  const sourceValue =
    typeof cell?.value?.value?.source === "string"
      ? cell?.value?.value?.source
      : JSON.stringify(cell?.value?.value?.source, null, 2);
  const targetValue =
    typeof cell?.value?.value?.target === "string"
      ? cell?.value?.value?.target
      : JSON.stringify(cell?.value?.value?.target, null, 2);

  const diffStyles = {
    variables: {
      light: {
        diffViewerBackground: "#fff",
        diffViewerColor: "#212529",
        addedBackground: "#e6ffed",
        addedColor: "#24292e",
        removedBackground: "#ffeef0",
        removedColor: "#24292e",
        wordAddedBackground: "#acf2bd",
        wordRemovedBackground: "#fdb8c0",
        addedGutterBackground: "#cdffd8",
        removedGutterBackground: "#ffdce0",
        gutterBackground: "#f7f7f7",
        gutterBackgroundDark: "#f3f1f1",
        highlightBackground: "#fffbdd",
        highlightGutterBackground: "#fff5b1",
      },
    },
    diffContainer: {
      width: "100%",
      minWidth: "400px",
      maxWidth: "100%",
      overflow: "auto",
      fontSize: "12px",
      fontFamily: "monospace",
    },
    line: {
      whiteSpace: "pre-wrap" as const,
      wordBreak: "break-word" as const,
      overflowWrap: "anywhere" as const,
    },
    content: {
      width: "100%",
      whiteSpace: "pre-wrap" as const,
      wordBreak: "break-word" as const,
      overflowWrap: "anywhere" as const,
    },
    contentText: {
      whiteSpace: "pre-wrap" as const,
      wordBreak: "break-word" as const,
      overflowWrap: "anywhere" as const,
    },
    gutter: {
      minWidth: "0",
      padding: "0 4px",
    },
    table: {
      width: "100%",
      tableLayout: "fixed" as const,
    },
    diffWrapper: {
      width: "100%",
      overflow: "auto",
    },
  };

  return (
    <div className="diff-container h-full w-full">
      <ReactDiffViewer
        oldValue={sourceValue}
        newValue={targetValue}
        splitView={false}
        hideLineNumbers
        showDiffOnly
        extraLinesSurroundingDiff={2}
        compareMethod={DiffMethod.WORDS}
        styles={diffStyles}
        useDarkTheme={false}
      />
    </div>
  );
};
